import React from 'react'
import styles from 'components/Filters/ActionButtons/action-buttons.module.scss'
import { Button, DropdownRow, Grid } from 'gu-ui-kit'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

const ActionButtons = ({
  showActionButtons = true,
  applyValue,
  dropFilter,
  disabledApplyAction = false,
}) => {
  const { t } = useTranslation()

  return showActionButtons ? (
    <DropdownRow>
      <Grid
        wrap={false}
        justifyContent="space-between"
        className={styles['action-buttons']}
        gap={16}
      >
        <Button
          onClick={dropFilter}
          type={'button'}
          variant={'ghost'}
          grey
          noWrap
        >
          {t('common::buttons.reset')}
        </Button>
        <Button
          onClick={applyValue}
          variant={'primary'}
          noWrap
          disabled={disabledApplyAction}
        >
          {t('common::buttons.apply')}
        </Button>
      </Grid>
    </DropdownRow>
  ) : null
}

export default ActionButtons

ActionButtons.propTypes = {
  disabledApplyAction: PropTypes.bool,
  showActionButtons: PropTypes.bool,
  applyValue: PropTypes.func,
  dropFilter: PropTypes.func,
}
